import { render } from "./ConversationVideoCall.vue.js?vue&type=template&id=85be103a!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationVideoCall.vue?vue&type=template&id=85be103a"
import script from "./ConversationVideoCall.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationVideoCall.vue?vue&type=script&lang=js"
export * from "./ConversationVideoCall.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationVideoCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/conversation-call/ConversationVideoCall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85be103a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85be103a', __exports__)) {
    api.reload('85be103a', __exports__)
  }
  
  module.hot.accept("./ConversationVideoCall.vue.js?vue&type=template&id=85be103a!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationVideoCall.vue?vue&type=template&id=85be103a", () => {
    api.rerender('85be103a', render)
  })

}


export default __exports__